(() => {
  const forms = document.querySelectorAll('[data-hj-collection-sort]');
  forms.forEach((form) => {
    const select = form.querySelector('select[name="sort_by"]');
    if (!select) return;

    select.addEventListener('change', () => {
      form.submit();
    });
  });
})();
